import { PublicBaseEventSerializer } from "@shared/modules/events/types/public"; // TODO move these types here - SPW-13349
import Repository, {
  ExtendedAxiosRequestConfig,
} from "@shared/services/api/abstracts/Repository";
import { CheckEventPasswordResponseType } from "../types/events";

export type CheckEventPasswordPayloadType = {
  password: string;
  slug: string;
  ticket_type?: number;
};

export default class PublicBaseEventRepository extends Repository<PublicBaseEventSerializer> {
  public readonly repositoryName = "PublicBaseEventRepository";

  public readonly endpoint = "/api/public/events/";

  public get urlMap() {
    return {
      ...this.defaultUrlMap,
      checkEventPassword: "{eventSlug}/password/check/",
      checkEventPasswordAuthorized: "{eventSlug}/password/check/",
      calendarEventDetails: "{eventSlug}/calendar/",
    };
  }

  /**
   * To check event passwords, we first need to check if the user is authorized to
   * access the event. If the user is not authorized, we have to prompt for a password
   * and submit this payload to the backend.
   *
   * 1. Check if event is protected
   * 2. Use GET {eventSlug}/password/check/ to check if permitted
   * 3. If not permitted, use POST {eventSlug}/password/check/ to check password
   */
  public async checkEventPassword(params: CheckEventPasswordPayloadType) {
    const { data } = await this.request<CheckEventPasswordResponseType>(
      this.buildUrl("checkEventPassword", {
        eventSlug: params.slug,
      }),
      { method: "POST", data: params }
    );

    return data;
  }

  /**
   * To check event passwords, we first need to check if the user is authorized to
   * access the event. If the user is not authorized, we have to prompt for a password
   * and submit this payload to the backend.
   *
   * 1. Check if event is protected
   * 2. Use GET {eventSlug}/password/check/ to check if permitted
   * 3. If not permitted, use POST {eventSlug}/password/check/ to check password
   */
  public async checkEventPasswordAuthorized(
    eventSlug: string,
    config?: ExtendedAxiosRequestConfig
  ) {
    const { data } = await this.request<{
      password_session_id: string;
      tickettypes: Array<number>;
    }>(
      this.buildUrl("checkEventPasswordAuthorized", {
        eventSlug,
      }),
      config
    );

    return data;
  }

  public async calendarEventDetails(
    eventSlug: string,
    config: ExtendedAxiosRequestConfig
  ) {
    const { data } = await this.request(
      this.buildUrl("calendarEventDetails", {
        eventSlug,
      }),
      config
    );

    return data;
  }
}
